<template>
  <UApp>
    <div>
      <NuxtLoadingIndicator />
      <NuxtLayout>
        <div>
          <NuxtPage />
        </div>
      </NuxtLayout>
    </div>
  </UApp>
</template>

<style lang="scss">
  @import '/styles/base.scss';
</style>
